const getters = {
  token: state => state.user.token,
  messagelist: state => state.websocket.messagelist, //活动留言数据
  lastmeeting: state => state.websocket.lastmeeting, // 最新活动信息
  num: state => state.websocket.num, //活动反馈数据 统计数据
  dai_comeInfo: state => state.websocket.dai_comeInfo, //待回复人员信息
  dai_sign: state => state.websocket.dai_come, //待回复人员信息
  no_comeInfo: state => state.websocket.no_comeInfo, //不参加人员信息
  comeInfo: state => state.websocket.comeInfo, //参加人员信息
  activity_id: state => state.websocket.activity_id, //参加人员信息
  // 签到页面
  dai_sign: state => state.websocket.dai_sign,
  no_come: state => state.websocket.no_come,
  situation: state => state.websocket.situation,
  // 留言板
  messagelist: state => state.websocket.messagelist,
  // 投票
  vote_main: state => state.websocket.vote_main,
  vote_item: state => state.websocket.vote_item,
  vote_total: state => state.websocket.vote_total,
  autoupdateapp: state => state.autoupdateapp
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js